export enum EmailTrigger {
  // Guests
  GUEST_CHECKIN = "GUEST_CHECKIN",
  GUEST_CHECKOUT = "GUEST_CHECKOUT",
  GUEST_CREATED = "GUEST_CREATED",
  GUEST_UPDATED = "GUEST_UPDATED",
  GUEST_DELETED = "GUEST_DELETED",
  REQUEST_SUBMITTED = "REQUEST_SUBMITTED",

  // RSVP + approval outcomes. `state` carries the GUEST's own answer,
  // `acceptanceState` the ORGANISER's verdict on a pending request; the
  // backend derives these from that diff (GuestService.deriveLifecycleTriggers).
  GUEST_ACCEPTED = "GUEST_ACCEPTED",
  GUEST_DECLINED = "GUEST_DECLINED",
  REQUEST_APPROVED = "REQUEST_APPROVED",
  REQUEST_DENIED = "REQUEST_DENIED",
  COMPANION_APPROVED = "COMPANION_APPROVED",
  COMPANION_DENIED = "COMPANION_DENIED",

  // "A companion row was created" — one trigger per door, kept together here
  // even though the picker files them under three different categories
  // (Website / Guests / Check-in app). They are mutually exclusive: exactly one
  // fires per created companion row.
  //
  // COMPANION_ADDED is the WEBSITE door and keeps its bare name because saved
  // pipe documents store this String; renaming it would orphan every rule
  // already built on it.
  COMPANION_ADDED = "COMPANION_ADDED",
  COMPANION_ADDED_ADMIN = "COMPANION_ADDED_ADMIN",
  COMPANION_ADDED_APP = "COMPANION_ADDED_APP",

  // GUEST_PROMOTED is offered by the picker (guests group, between the
  // companion verdicts and check-in) — it fires on automatic waitlist
  // promotion, which is the one door that admits a guest with nobody
  // clicking.
  GUEST_PROMOTED = "GUEST_PROMOTED",
  // Legacy — kept so this mirror matches the Java enum (the drift gate
  // compares the SETS). Deliberately absent from the picker in
  // default-returner.ts and humanized by triggerLabel.ts: it has no fire site
  // at all, so offering it would promise an automation that never runs.
  APPOINTMENT_REMINDER = "APPOINTMENT_REMINDER",

  // Website
  GUEST_CREATED_WEBSITE = "GUEST_CREATED_WEBSITE",
  GUEST_UPDATED_WEBSITE = "GUEST_UPDATED_WEBSITE",

  // Check-In App
  // The door's walk-up create: a brand-new guest who was never on the list.
  // ADDITIVE to GUEST_CREATED — main-backend enqueues both for the one insert
  // (unlike the mutually exclusive COMPANION_ADDED family, where each door
  // fires its own member and nothing else). Fired by main-backend on the
  // device's behalf (InternalCheckinResource /walk-up), never by the Worker.
  GUEST_CREATED_APP = "GUEST_CREATED_APP",
  GUEST_CHECKIN_APP = "GUEST_CHECKIN_APP",
  GUEST_CHECKOUT_APP = "GUEST_CHECKOUT_APP",
  GUEST_UPDATED_APP = "GUEST_UPDATED_APP",
  GUEST_APPOINTMENT_CHECKIN_APP = "GUEST_APPOINTMENT_CHECKIN_APP",
  GUEST_SEATING_CHECKIN_APP = "GUEST_SEATING_CHECKIN_APP",

  // Appointments
  APPOINTMENT_CREATED = "APPOINTMENT_CREATED",
  APPOINTMENT_CONFIRMED = "APPOINTMENT_CONFIRMED",
  APPOINTMENT_CANCELLED = "APPOINTMENT_CANCELLED",
  APPOINTMENT_CHECKED_IN = "APPOINTMENT_CHECKED_IN",
  APPOINTMENT_WAITLIST_JOINED = "APPOINTMENT_WAITLIST_JOINED",
  APPOINTMENT_WAITLIST_PROMOTED = "APPOINTMENT_WAITLIST_PROMOTED",
  APPOINTMENT_REQUEST_CREATED = "APPOINTMENT_REQUEST_CREATED",
  APPOINTMENT_BELOW_THRESHOLD = "APPOINTMENT_BELOW_THRESHOLD",
  STAFF_CANCELLATION_ALERT = "STAFF_CANCELLATION_ALERT",

  // Seating
  SEAT_ASSIGNED = "SEAT_ASSIGNED",
  SEAT_UNASSIGNED = "SEAT_UNASSIGNED",
  SEAT_CONFIRMED = "SEAT_CONFIRMED",
  SEAT_RESERVED = "SEAT_RESERVED",

  // Scheduled — workflow broadcasts its SEND_EMAIL at a chosen time
  SCHEDULED = "SCHEDULED",
}
